

import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = ({ stats }) => {
  const cards = stats && stats.length
    ? stats
    : [
        { title: "Yükleniyor...", value: "—", icon: "fas fa-spinner", color: "bg-default" },
      ];

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row>
              {cards.map((card, i) => (
                <Col lg="6" xl="3" key={i}>
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            {card.title}
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {card.value}
                          </span>
                        </div>
                        <Col className="col-auto">
                          <div className={`icon icon-shape ${card.color || "bg-danger"} text-white rounded-circle shadow`}>
                            <i className={card.icon || "fas fa-chart-bar"} />
                          </div>
                        </Col>
                      </Row>
                      {card.detail && (
                        <p className="mt-3 mb-0 text-muted text-sm">
                          <span className="text-nowrap">{card.detail}</span>
                        </p>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
